import { ThisGorillaUtils } from "@thisgorilla/primate-ds";
import styled from "styled-components";
import { FlexColumn, FlexRowSpaced } from "../../Styles";

export const Container = styled.div`
  border: 1px solid
    ${({ theme }) => theme.Color.border["ui-border-neutral"].value};
  border-radius: ${({ theme }) => theme.radius["radius-xl"].value}rem;
  width: 100%;
  position: relative;
`;

export const BackButtonContainer = styled.div`
  position: absolute;
  top: ${({ theme }) => theme.spacing["spacing-4"].value}rem;
  left: ${({ theme }) => theme.spacing["spacing-4"].value}rem;
`;

export const CoverImage = styled.img`
  display: block;
  width: 100%;
  border-top-left-radius: ${({ theme }) => theme.radius["radius-xl"].value}rem;
  border-top-right-radius: ${({ theme }) => theme.radius["radius-xl"].value}rem;
`;

export const Wrapper = styled(FlexColumn)`
  padding: ${({ theme }) => theme.spacing["spacing-4"].value}rem;
  gap: ${({ theme }) => theme.spacing["spacing-4"].value}rem;
  border-bottom-left-radius: ${({ theme }) =>
    theme.radius["radius-xl"].value}rem;
  border-bottom-right-radius: ${({ theme }) =>
    theme.radius["radius-xl"].value}rem;
  background: ${({ theme }) =>
    theme.Color.elevation.surface["surface-primary"].value};

  & > label {
    text-align: center;
  }
`;

export const UserInfoContainer = styled(FlexColumn)`
  padding: ${({ theme }) => theme.spacing["spacing-05"].value}rem;
  width: ${ThisGorillaUtils.convertPxToRem("241")}rem;
`;

export const CardFooter = styled(FlexRowSpaced)`
  padding: ${({ theme }) => theme.spacing["spacing-2"].value}rem
    ${({ theme }) => theme.spacing["spacing-none"].value}rem;
`;
